import type { PermittedCustomer, UserInfo } from "@/redux/types/customerTypes";
import { setSelectedKey } from "../../redux/slices/customerSlice";
import { getItem } from "../../utils/common";
import { DASHBOARD, GENERAL, GLOBAL_LOGS, GLOBAL_MAPS, LOGS, MAINTENANCE, MAPS, REMOTE, MANUALS, SUPPORT, DOCUMENTATION } from "../../utils/constants";
import { CustomerServiceOutlined, ReadOutlined } from '@ant-design/icons';
import { General, GeneralGreen, globalDashboard, globalDashboardGreen, Maintenance, MaintenanceGreen, Maps, MapsGreen, Loki, LokiGreen } from "./Assets";
import Docs from '../../assets/sideNav/Docs.svg';
import DocsGreen from '../../assets/sideNav/selected/Docs.svg';
import { hasUserPermission } from "../../utils/permissionUtils";


const generateNavItems = (
    selectedCustomerName: string | undefined,
    selectedSite: string | undefined,
    selectedKey: string,
    permittedCustomers: PermittedCustomer[],
    dispatch: any,
    navigate: (path: string) => void,
    userInfo: UserInfo | null
): any[] => {

    const createNavItem = (
        key: string,
        label: string,
        icon: string,
        iconSelected: string,
        path: string,
        onClickExtra?: () => void
    ) =>
        getItem(
            key,
            label,
            <img
                src={selectedKey === label ? iconSelected : icon}
                className="colorChangeWhenSelected"
                alt={label}
            />,
            null,
            () => {
                dispatch(setSelectedKey(label));
                navigate(path);
                if (onClickExtra) onClickExtra();
            }
        );

    const navItems = [
        createNavItem('DASHBOARD', DASHBOARD, globalDashboard, globalDashboardGreen, `/${selectedCustomerName}/${DASHBOARD}`),
        hasUserPermission(userInfo, MAPS, selectedCustomerName || '') && createNavItem('GLOBAL MAPS', GLOBAL_MAPS, Maps, MapsGreen, `/${selectedCustomerName}/${GLOBAL_MAPS}`),
        permittedCustomers && permittedCustomers.filter((data) => data.customer === selectedCustomerName)?.[0]?.preferences?.remote && hasUserPermission(userInfo, REMOTE, selectedCustomerName || '') && createNavItem('REMOTE ACCESS', REMOTE, General, GeneralGreen, `/${selectedCustomerName}/${REMOTE}`),
        createNavItem('GENERAL', GENERAL, General, GeneralGreen, `/${selectedCustomerName}/${selectedSite}/${GENERAL}`),
        permittedCustomers && permittedCustomers.filter((data) => data.customer === selectedCustomerName)?.[0]?.preferences?.manuals && createNavItem('DOWNLOADS', MANUALS, Docs, DocsGreen, selectedSite ? `/${selectedCustomerName}/${selectedSite}/${MANUALS}` : `/${selectedCustomerName}/${MANUALS}`),
        permittedCustomers && permittedCustomers.filter((data) => data.customer === selectedCustomerName)?.[0]?.preferences?.globalLogs && hasUserPermission(userInfo, LOGS, selectedCustomerName || '') && createNavItem('LOGS', GLOBAL_LOGS, Loki, LokiGreen, `/${selectedCustomerName}/${LOGS}`),
        permittedCustomers && permittedCustomers.filter((data) => data.customer === selectedCustomerName)?.[0]?.preferences?.documentation && getItem(
            'DOCUMENTATION',
            DOCUMENTATION,
            <ReadOutlined style={{ fontSize: '22px', color: selectedKey === DOCUMENTATION ? '#38B34A' : undefined }} />,
            null,
            () => {
                const link = document.createElement('a');
                link.href = '/eboost-docs/';
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                link.click();
            }
        ),
        permittedCustomers && permittedCustomers.filter((data) => data.customer === selectedCustomerName)?.[0]?.preferences?.support && getItem(
            'SUPPORT',
            SUPPORT,
            <CustomerServiceOutlined style={{ fontSize: '22px', color: selectedKey === SUPPORT ? '#38B34A' : undefined }} />,
            null,
            () => {
                dispatch(setSelectedKey(SUPPORT));
                navigate(`/${selectedCustomerName}/${SUPPORT}`);
            }
        ),
    ].filter(Boolean);

    const maintenanceEnabled = permittedCustomers.find(
        c => c.customer === selectedCustomerName
    )?.preferences?.maintenance;

    if (selectedCustomerName && permittedCustomers.length > 0 && maintenanceEnabled && hasUserPermission(userInfo, MAINTENANCE, selectedCustomerName)) {
        navItems.splice(
            2,
            0,
            getItem(
                'MAINTENANCE',
                MAINTENANCE,
                <img
                    src={selectedKey === MAINTENANCE ? MaintenanceGreen : Maintenance}
                    className="colorChangeWhenSelected"
                    alt="maintenance"
                />,
                null,
                () => {
                    dispatch(setSelectedKey(MAINTENANCE));
                    const path = selectedSite
                        ? `/${selectedCustomerName}/${selectedSite}/${MAINTENANCE}`
                        : `/${selectedCustomerName}/${MAINTENANCE}`;
                    navigate(path);
                }
            )
        );
    }

    return navItems;
};
export default generateNavItems;